import api from "../services/api"
import { toast } from "react-toastify"

const saveNewLead = async (newLead) => {
    try {
        const response = await api.post("/leads", newLead)
        return response.data?.data
    } catch (err) {
        toast.error(err?.response?.data?.message)
        throw err
    }
}

const requestLeadAccess = async (leadId, data) => {
    try {
        const response = await api.post(`/leads/${leadId}/access-requests`, data)
        toast.success(response.data?.message)
        return response.data?.data
    } catch (err) {
        toast.error(err?.response?.data?.message)
        throw err
    }
}

const decideLeadAccessRequest = async (requestId, data) => {
    try {
        const response = await api.patch(`/leads/access-requests/${requestId}`, data)
        toast.success(response.data?.message)
        return response.data?.data
    } catch (err) {
        toast.error(err?.response?.data?.message)
        throw err
    }
}

export { saveNewLead, requestLeadAccess, decideLeadAccessRequest }
